import React from "react";

interface RenameIconProps {
  size?: number | string;
  color?: string;
  className?: string;
  onClick?: () => void;
}

const RenameIcon: React.FC<RenameIconProps> = ({
  size = 16,
  color = '#373F51',
  className,
  onClick,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    onClick={onClick}
  >
    <path
      d="M6.00016 14.6667H10.0002C13.3335 14.6667 14.6668 13.3333 14.6668 10V6.00001C14.6668 2.66668 13.3335 1.33334 10.0002 1.33334H6.00016C2.66683 1.33334 1.3335 2.66668 1.3335 6.00001V10C1.3335 13.3333 2.66683 14.6667 6.00016 14.6667Z"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.6665 5.92666C6.7665 4.88 9.23317 4.88 11.3332 5.92666"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.8667V5.28665"
      stroke={color}
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default RenameIcon;
